"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersionAsPathString = void 0;
const getVersionAsPathString = (defaultVersionNum, givenVersionNum) => {
    return givenVersionNum ? `v${givenVersionNum}` : `v${defaultVersionNum}`;
};
exports.getVersionAsPathString = getVersionAsPathString;
//# sourceMappingURL=VersionUtils.js.map